import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { filter } from 'rxjs';
import { SettingsState } from '@store/states/settings.state';

@Injectable({
  providedIn: 'root',
})
export class SettingsResolver {
  constructor(private readonly store: Store) {}

  resolve() {
    return this.store.select(SettingsState.settings).pipe(filter(Boolean));
  }
}
